import { Component, ojs, app, state, v } from "modular-openscriptjs";
import { empty, inform, pageInfo } from "../../../helpers";
import { api, STRINGS } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";

const h = app("h");

ojs(SolidIcon);

export default class ManageSupportInfo extends Component {
  businessId = null;
  business = state(null);

  formData = {
    support_email: "",
    support_phone: "",
    support_link: "",
  };

  render() {
    const router = app("router");
    this.businessId = router.params.companyId;
    scrollToTop();

    if (!this.business.value) {
      this.fetchBusiness();
    }

    return h.div(
      { class: "min-vh-100 py-5 mb-5 py-md-5" },
      h.div(
        { class: "container" },
        h.div(
          { class: "mb-4 d-flex align-items-center gap-3" },
          h.button(
            {
              class: "btn btn-white border shadow-sm rounded-circle p-2",
              onclick: "history.back()",
            },
            h.SolidIcon("arrow-left"),
          ),
          h.h2({ class: "fw-bold mb-0" }, "Support Information"),
        ),

        v(this.business, (b) => {
          if (!b.value)
            return h.div({ class: "text-center py-5" }, h.Spinner());

          return h.div(
            { class: "card border-0 shadow-sm rounded-4" },
            h.div(
              { class: "card-body p-4" },
              h.div(
                { class: "row g-3" },
                h.div(
                  { class: "col-12" },
                  h.label(
                    {
                      class:
                        "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Support Email",
                  ),
                  h.input({
                    class: "form-control fs-3",
                    type: "email",
                    value: b.value.support_email,
                    listeners: {
                      input: (e) =>
                        (this.formData.support_email = e.target.value),
                    },
                  }),
                ),
                h.div(
                  { class: "col-12" },
                  h.label(
                    {
                      class:
                        "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Support Phone",
                  ),
                  h.input({
                    class: "form-control fs-3",
                    type: "tel",
                    value: b.value.support_phone,
                    listeners: {
                      input: (e) =>
                        (this.formData.support_phone = e.target.value),
                    },
                  }),
                ),
                h.div(
                  { class: "col-12" },
                  h.label(
                    {
                      class:
                        "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Website/Support Link",
                  ),
                  h.input({
                    class: "form-control fs-3",
                    type: "url",
                    value: b.value.support_link,
                    listeners: {
                      input: (e) =>
                        (this.formData.support_link = e.target.value),
                    },
                  }),
                  h.div(
                    { class: "form-text small text-muted mt-1" },
                    "WhatsApp or chat link for customer inquiries. Get your WhatsApp link ",
                    h.a(
                      {
                        href: "https://create.wa.link/",
                        target: "_blank",
                        class: "text-primary text-decoration-none",
                      },
                      "here"
                    ),
                    "."
                  ),
                ),
                h.div(
                  { class: "col-12 text-end mt-4" },
                  h.button(
                    {
                      class: "btn btn-primary px-3",
                      onclick: this.method("updateBusiness", ["${this}"]),
                    },
                    "Save Changes",
                  ),
                ),
              ),
            ),
          );
        }),
      ),
    );
  }

  async fetchBusiness() {
    try {
      const res = await api.get(`companies/${this.businessId}`);
      if (res) {
        this.business.value = res.data.company;
        this.formData.support_email = res.data.company.support_email;
        this.formData.support_phone = res.data.company.support_phone;
        this.formData.support_link = res.data.company.support_link;
      }
    } catch (e) {
      console.error(e);
    }
  }

  async updateBusiness(btn) {
    if (empty(this.formData.support_phone)) {
      return inform("Support phone is required!", STRINGS.ERROR);
    }

    try {
      dom.disable(btn);
      h.Spinner({ parent: btn, resetParent: true });

      const res = await api.put(`companies/${this.businessId}`, this.formData);

      if (res) {
        inform("Business support information updated successfully!", STRINGS.SUCCESS);
      }
    } catch (e) {
      inform("Failed to update business support information", STRINGS.ERROR);
    } finally {
      dom.enable(btn);
      h.span("Save Changes", { parent: btn, resetParent: true });
    }
  }
}

ojs(ManageSupportInfo);
